import React from 'react';
import { Box, Typography } from '@mui/material';
import { boxStyle } from './style/BoxStyle';

const AccessDenied = () => {
    return (
        <Box sx={boxStyle}>
            <Typography variant="body1" mb={2}>
                You don’t have permission to view an admin account.<br />
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={4}>
                If you believe this is a mistake, please contact your system administrator.
            </Typography>
        </Box>
    );
};

export default AccessDenied;
